import { FC } from "react";
import styled from "styled-components";

const EyeButton = styled.button`
  width: 38px;
  height: 38px;
  background: ${({ theme }) => theme.colors.lightGray};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease-out 0.2s;
  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.purpleLighter};
  }
  &:active {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.purple};
  }
`;

interface Props {
  onToggle: () => void;
  isOpen: boolean;
}

const ToggleButton: FC<Props> = ({ onToggle, isOpen }) => {
  return (
    <EyeButton onClick={onToggle}>
      {isOpen ? (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 3.93695C3.375 3.93695 1.125 9 1.125 9C1.125 9 3.375 14.062 9 14.062C14.625 14.062 16.875 9 16.875 9C16.875 9 14.625 3.93695 9 3.93695Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 11.8125C10.5533 11.8125 11.8125 10.5533 11.8125 9.00003C11.8125 7.44673 10.5533 6.18753 9 6.18753C7.4467 6.18753 6.1875 7.44673 6.1875 9.00003C6.1875 10.5533 7.4467 11.8125 9 11.8125Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1426 8.95312L15.7464 11.731"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.8418 10.4922L11.342 13.3289"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.15261 10.4922L6.65234 13.3293"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.85373 8.94922L2.24219 11.7405"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 7.375C3.43213 8.83824 5.59927 10.6885 9.00004 10.6885C12.4008 10.6885 14.5679 8.83825 15.7501 7.37502"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </EyeButton>
  );
};

export default ToggleButton;
